import React from 'react';
import {translations} from 'presentation/translations-new';
import {MainHeader, PageWrapperLayout} from 'presentation/components';
import {useHostName} from 'presentation/hooks';
import {Navigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {useBeneficiaryToken} from './hooks/useBeneficiaryToken';

const {title} = translations['pt-br'].privateFlow.token;

export function BeneficiaryTokenWrapper() {
	const {handleBack} = useBeneficiaryToken();
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();

	if (!isGndiSaoPaulo && !isNotredameSaude) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				title={title}
				variant="subRoute"
				handleBack={handleBack}
				handleClose={handleBack}
			/>
		</PageWrapperLayout>
	);
}
